import { useState} from 'react';
import {Modal, Col, Row, Form} from 'react-bootstrap';
import { FormInput } from '../../formElements/FormInput';
import BaseService from "../../../services/BaseService";
import CommonService from "../../../services/CommonService";
import { AlertType} from "../../../utils";

export default function SecurityContainer(props) {
    const [unlocked, setUnlocked] = useState(false);
    const [authorizationInput, setAuthorizationInput] = useState('');
    const [authCodeValid, setAuthCodeValid] = useState(false);

    const handleSubmit = async() => {
        const enteredCodeValid = await fetchData();

        if (enteredCodeValid) {
            
            setUnlocked(true);
            setAuthCodeValid(false);
        }
        else {
            setAuthCodeValid(true);
        }

    }

    const fetchData = async () => {
        CommonService.showHideSpinner(true);
        let validCode = false;
        var obj = {
            msgId: null,
            sysId: null,
            opr: "checkAdminAuthorizationCode",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "adminUIAuthorization": {
                    "authorizationCode": authorizationInput
                }
            },
        };

        await BaseService.processRequest(obj)
            .then((res) => res)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    CommonService.displayServerMessage(result.data.errors[0].message, AlertType.Error);
                }
                else {
                    validCode = result.data.responses[0].isValidCode;
                }
                CommonService.showHideSpinner(false);
            });
            return validCode;
    }

    return (
        <div>
            {unlocked ? props.children : 
                <Modal show={true} backdrop="static">
                    <Modal.Header closeButton><h3>Password Verification</h3></Modal.Header>
                    <Modal.Body>
                        <Form id="verify-form">
                            <Row>
                                <Col>
                                    <FormInput
                                        label="Enter Authorization Code"
                                        type="password"
                                        value={authorizationInput}
                                        onChange={e => setAuthorizationInput(e.target.value)}
                                    />
                                    {authCodeValid && <p className="error">Invalid Password</p>}
                                    <div style={{overflow: 'auto'}}>
                                        <div className="fleft">
                                        <a href="/admin" className="dk-blue-color link-button">Back to Admin</a>
                                        </div>
                                        <div className="fright">
                                            <button className="custom-button" type="button" onClick={(e)=>handleSubmit()}>Submit</button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                </Modal>
            }
      </div>
    )
}